import type { ReactNode } from 'react';

export type BadgeVariant = 'success' | 'info';

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
  'data-testid'?: string;
}

const VARIANT_CLASS: Record<BadgeVariant, string> = {
  success: 'ds-badge ds-badge-success',
  info: 'ds-badge ds-badge-info',
};

/**
 * Small label chip (e.g. "Recommended", "Architecture V2").
 */
export function Badge({
  children,
  variant = 'info',
  className = '',
  'data-testid': dataTestId,
}: BadgeProps) {
  return (
    <span
      data-testid={dataTestId ?? 'design-system-badge'}
      className={`${VARIANT_CLASS[variant]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
